import $ from "jquery";
import "@babel/polyfill";
import Foundation from "./_foundation"; // import "motion-ui/dist/motion-ui";
// import AOS from 'aos'

import throttle from "lodash/throttle";
import { inlineSVG } from "./_inline-svg";
import { lazyImages, lazyBackgrounds, lazyVideos, lazyOembeds, lazyInterchange } from "./_lazy-load";
import "./_skip-link-focus-fix";
import "./_fixed-header";
import "./_header-height";
import "./_notification";
import "./_slick";
import "./_off-canvas";
import "./_site-header-search";
import "./_ie";
import "../../node_modules/focus-visible/dist/focus-visible.min.js";
import { equalHeights } from "./_equal-heights";
import "./_faqs_accordion";
import { smoothScrollOnPageLoad } from "./_smoothScrollOnPageLoad";
import "./_defer-oembed"; // import "./_acf-map";
// import "./_scroll-to-top";
// import './_social-share-sticky';
// Foundation

$(document).foundation(); // Inline SVG

inlineSVG();
smoothScrollOnPageLoad(); // Smooth Scroll on page load
// smoothScrollOnPageLoad();
// Lazy-load on DOMContentLoaded

window.addEventListener("DOMContentLoaded", function () {
  lazyImages();
  lazyBackgrounds();
  lazyVideos();
  lazyOembeds();
  lazyInterchange();
  setTimeout(function () {//equalHeights( '.page-template-howitworks-page .why-limelight__grid .why-limelight__item' );
  }, 500);
}, false); // Lazy-load on scroll event

window.addEventListener("scroll", throttle(lazyImages, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyBackgrounds, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyOembeds, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyInterchange, 75), {
  passive: true
}); // Slick slider within tabs

var slickTabs = function slickTabs(_ref) {
  var sliderSelector = _ref.sliderSelector,
      fadeInDuration = _ref.fadeInDuration;
  $(document).on("change.zf.tabs", function (event, tab) {
    var _tab = tab;
    $(sliderSelector).css("opacity", "0");
    setTimeout(function () {
      var $showSliderForTheActiveTab = $(".tabs-panel.is-active .js-collection-slider"); // Fake window resize to trick slick slider to activate when a sliders tab is active.

      $showSliderForTheActiveTab.slick("setPosition");
      $showSliderForTheActiveTab.animate({
        opacity: 1
      }, fadeInDuration);
    }, 100);
  });
};

slickTabs({
  sliderSelector: ".js-collection-slider",
  fadeInDuration: 250
});
/**
 * Collections CTA
 *
 * This script changes the Collection CTA based on the tab selected:
 * https://share.getcloudapp.com/Apuk7XN2
 */

$(".collections .tabs-title > a").click(function () {
  var _tab = $(this).parent();

  var tabindex = _tab.index() + 1;
  $(".collections__cta-container").removeClass("is-active");
  $(".collections__cta-container:nth-child(" + tabindex + ")").addClass("is-active");
});
jQuery(function ($) {
  $(document).on("change.zf.tabs", function (event, tab) {// setTimeout(function() {
    // }, 100);
  });
}); // AOS
// AOS.init();

/**
 *
 */

jQuery(document).ready(function () {
  if (jQuery("div.validation_error").length != 0) {
    document.body.classList.add("js-gf-validation-error");
  }
}); // https://gist.github.com/nathansmith/522250/f72516b9c5e7d26b9995db842e3f2d0a75ca6d6d
// $('select.jump_list').change(function() {
//     if (!this.value) {
//         return;
//     }
//     var url = window.location.toString();
//     var url_len = url.length;
//     var last_char = url.substring(url_len - 1, url_len);
//     if (this.value.match('://')) {
//         window.top.location = this.value;
//     }
//     else {
//         if (last_char === '/') {
//             window.top.location = url + this.value;
//         }
//         else {
//             window.top.location = url + '/' + this.value;
//         }
//     }
// });
// Tooltip

var $info = $(".info");
$(".info").on("click", function (e) {
  e.preventDefault();
  $(this).find(".info-tooltip").addClass("tooltip-is-visible");
});
$(".nv-close-button").on("click", function (e) {
  e.preventDefault();
  setTimeout(function () {
    $(".tooltip-is-visible").removeClass("tooltip-is-visible");
  }, 100);
}); // Product page tooltip
// Create a media condition that targets viewports at least 768px wide

var mediaQuery = window.matchMedia("(min-width: 768px)");
var $productThumbs = $(".woocommerce-product-gallery__wrapper > div[data-thumb]"); // Check if the media query is true

if (mediaQuery.matches) {
  if ($productThumbs.length > 1 && $productThumbs.length <= 5) {
    $("#js-ghostimage-info").appendTo(".woocommerce-product-gallery__wrapper").css("display", "inline-flex");
  } else {
    $("#js-ghostimage-info").appendTo(".woocommerce-product-gallery__wrapper").css("display", "inline-flex").addClass("move-below-thumbnails");
  }
} else {
  $("#js-ghostimage-info").prependTo(".summary.entry-summary").css("display", "inline-flex");
} // Product page Addtional infomation accordion


$(".additional-info__button").on("click", function (e) {
  e.preventDefault();
  $(this).next().toggleClass("is-visible");
}); // Init detection on load
//detectScrollDirection();

/**
 * Renter Sizer page
 */
// jQuery(".gfield_price .gfield_label").on("click", function () {
//     var $quantityField = $(this)
//         .next(".ginput_container")
//         .find(".ginput_quantity");
//     $quantityField.val("1");
//     setTimeout(function () {
//         $quantityField.get(0).onchange();
//     }, 1000);
// });
// jQuery('#gform_6').find('.ginput_quantity').on('change', function(){
//     jQuery( '.gfield_price .gfield_label' ).on( 'click', function () {
//         var $quantityField = $(this).next('.ginput_container').find('.ginput_quantity');
//         $quantityField.val( '1' );
//     } );
//     $('.ginput_total .ginput_total_6').change();
// });
// gform.addAction( 'gform_post_calculation_events', function ( mergeTagArr, formulaField, formId, calcObj ) {
//     var fieldId = parseInt( mergeTagArr[1] ),
//         fieldSelector = '#field_' + formId + '_' + fieldId;
//     if ( jQuery( fieldSelector + ' table.gfield_list' ).length == 1 ) {
//         jQuery( fieldSelector )
//             .on( 'click', '.add_list_item', function () {
//                 jQuery( fieldSelector + ' .delete_list_item' ).removeProp( 'onclick' );
//                 calcObj.bindCalcEvent( fieldId, formulaField, formId, 0 );
//             } )
//             .on( 'click', '.delete_list_item', function () {
//                 gformDeleteListItem( this, 0 );
//                 calcObj.bindCalcEvent( fieldId, formulaField, formId, 0 );
//             } )
//             .on( 'change', ':input', function () {
//                 calcObj.bindCalcEvent( fieldId, formulaField, formId, 0 );
//             } );
//     }
// } );
// Move Bulk Chart
// if ($(".wc-bulk-variations-table-wrapper").length && $(".accordion").length) {
//     $(".wc-bulk-variations-table-wrapper").prependTo($(".js-variations"));
//     $(".woocommerce-Price-amount").remove();
//     $(".wcbvp-total-left").hide();
//     $(".wcbvp-cart").prependTo($(".js-btn-cart"));
//     $("#product-row-BREAK").empty();
//     $("#product-row-BREAK2").empty();
//     $("#product-row-BREAK3").empty();
//     $("#product-row-break").empty();
//     $("#product-row-break2").empty();
//     $("#product-row-break3").empty();
//     $("tbody tr:first-child").children("td").last().text("Quantity");
//     $("tbody #product-row-BREAK").next().children("td").last().text("Quantity");
//     $("tbody #product-row-break").next().children("td").last().text("Quantity");
//     $("tbody #product-row-BREAK2")
//         .next()
//         .children("td")
//         .last()
//         .text("Quantity");
//     $("tbody #product-row-break2")
//         .next()
//         .children("td")
//         .last()
//         .text("Quantity");
// } else {
//     // $(".wc-bulk-variations-table-wrapper").remove();
// }

var buttonTrigger = false;
$(".js-decline").on("click", function (e) {
  e.preventDefault;
  $(this).addClass("active");
  $(".js-accept").removeClass("active");
  buttonTrigger = true;
  $(".custom-acc").empty().hide();
});
$(".js-accept").on("click", function (e) {
  e.preventDefault;
  $(this).addClass("active");
  $(".js-decline").removeClass("active");
  buttonTrigger = false;
  var names = $(".custom-acc"),
      breaks = [],
      last = $(".wc-bulk-variations-table tbody tr").length + 1; // names.empty();

  names.show();
  $(".this-important").css({
    display: "block"
  }); // Record Breaks

  $(".wc-bulk-variations-table tbody tr").each(function (index, value) {
    if (~$(this).attr("id").indexOf("break")) {
      breaks.push(index);
    }
  });
  breaks.push($(".wc-bulk-variations-table tbody tr").length + 1); // Create Items

  $.each(breaks, function (i, v) {
    var previousIndex = i - 1 < 0 ? last : i - 1 >= 0 ? i - 1 : 0,
        base = $("<div />");
    $(".wc-bulk-variations-table tbody tr").each(function (index, value) {
      $(this).attr("data-id", index);
      $(this).attr("data-size", $(this).find("span").text());
      if (index >= v) return false;
      if (index <= breaks[previousIndex]) return;

      if (index == 0 || index == breaks[previousIndex] + 1) {
        $("<a />").addClass("custom-acc__title").html($(this).find("span").text()).appendTo(names);
        return;
      }

      var sizeContainer = $("<ul />").addClass("custom-acc__item item-" + index),
          quantity = $(this).find("input").val();

      if (quantity > 0) {
        for (var size = 0; size < quantity; size++) {
          var item = $("<li />").addClass("item-" + index + "-" + size);
          $("<span />").text("Size " + $(this).find("span").text()).appendTo(item);
          $('<input type="text" placeholder="Enter Name" />').attr("id", "item-" + index + "-" + size).appendTo(item);
          $("<a />").addClass("js-disable").attr("data-trigger", "item-" + index + "-" + size).html('<i class="far fa-times"></i>').appendTo(item);
          item.appendTo(sizeContainer);
        }
      }

      sizeContainer.attr("data-product", $(this).find("input").data("product_id")).appendTo(base);
    });
    base.addClass("item-container").appendTo(names);
  });
}); // $(".wcbvp_quantity").on("change", function (e) {
//     let val = $(this).val(),
//         id = $(this).parent().parent().data("id"),
//         text = $(this).parent().parent().data("size"),
//         fields = $(".item-" + id + " li").length;
//     if (val == 0) {
//         $(".item-" + id).empty();
//         return false;
//     }
//     if (val < fields) {
//         $(".item-" + id + " li")
//             .last()
//             .remove();
//         return false;
//     }
//     if (val >= fields) {
//         for (let size = fields; size < val; size++) {
//             var item = $("<li />").addClass("item-" + id + "-" + size);
//             $("<span />")
//                 .text("Size " + text)
//                 .appendTo(item);
//             $('<input type="text" placeholder="Enter Name" />')
//                 .attr("id", "item-" + id + "-" + size)
//                 .appendTo(item);
//             $("<a />")
//                 .addClass("js-disable")
//                 .attr("data-trigger", "item-" + id + "-" + size)
//                 .html('<i class="far fa-times"></i>')
//                 .appendTo(item);
//             item.appendTo($(".item-" + id));
//         }
//     }
// });

$(".loading").fadeOut("fast");
$(".recommended").fadeOut("fast");
$(".page-1 .populate-posts select").change(function (e) {
  e.preventDefault();
  $(".loading").fadeIn();
  var $this = $(this); // $(".recommended").fadeIn();

  var loadItem = $this.val();
  $.ajax({
    type: "GET",
    url: ajax_object.resturl + loadItem.split("|")[0],
    success: function success(response) {
      $(".js-img").attr("src", response.image);
      $(".js-product-name").text(response.product);
      $(".loading").fadeOut();
    }
  });
});

if ($("#gform_page_8_2").is(":visible")) {
  $(".page-2").show();
  $(".page-1").hide();
} else {
  $(".page-1").show();
  $(".page-2").hide();
}

if ($("#gform_page_9_2").is(":visible")) {
  $(".page-2").show();
  $(".page-1").hide();
} else {
  $(".page-1").show();
  $(".page-2").hide();
}

$(".js-mobile-move").each(function () {
  $(this).clone().removeClass("js-mobile-move").appendTo($(".js-mobile-attach"));
});
$(document).on("click", ".custom-acc__title", function (e) {
  e.preventDefault();
  var $class = $(e.target).next(".item-container").hasClass("active");
  $(".item-container.active").not(e.target).removeClass("active").slideUp();

  if (!$class) {
    $(e.target).next(".item-container").addClass("active").slideDown();
  } else {
    $(e.target).next(".item-container").removeClass("active").slideUp();
  }
});
$(document).on("click", ".js-disable", function (e) {
  e.preventDefault();
  var unit = $("#" + $(e.currentTarget).data("trigger")).attr("disabled");

  if (typeof unit !== "undefined" && unit !== false) {
    $("#" + $(e.currentTarget).data("trigger")).val("").removeAttr("disabled");
  } else {
    $("#" + $(e.currentTarget).data("trigger")).val("NO NAME").attr("disabled", "disabled");
  }
}); // Build Names

$(".single_add_to_cart_button").on("click", function (e) {
  if (buttonTrigger) {
    buttonTrigger = false;
    return;
  }

  e.preventDefault(); // Populate Array

  var items = [];
  $("ul.custom-acc__item").each(function (index, value) {
    var id = $(this).data("product");
    items[index] = [];
    items[index].push(id);
    $(this).children("li").each(function (i, v) {
      var text = $(this).find("input").val();
      items[index].push(text);
    });
  });
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "add_custom_names",
      custom_names: items
    },
    success: function success(data) {
      buttonTrigger = true;
      $(".single_add_to_cart_button").trigger("click");
    }
  });
});
$(document).on("click", ".design-item", function (e) {
  $(".design-item").removeClass("selected");
  $(this).addClass("selected");
}); // New Logic Order Total

$(".js-item input").on("change", function (e) {
  e.preventDefault();
  var $total = 0;
  $(".js-item input").each(function (e, v) {
    if ($(this).val() != "") $total = parseFloat($total) + parseFloat($(this).val());
  });
  $(".js-total").text($total);
});
$(".js-yes").on("click", function (e) {
  //debugger;
  e.preventDefault();
  $(this).toggleClass("active");
  $(".js-no").removeClass("active");
  var popupContainer = $(this).closest(".product-modal"); // Find the parent popup container

  var names = popupContainer.find(".custom-acc"),
      //var names = $(".custom-acc"),
  breaks = [];
  names.empty(); //$(".product-modal__container").fadeIn();

  popupContainer.find(".product-modal__container").fadeIn();
  popupContainer.find(".js-item").each(function (index, value) {
    if ($(this).hasClass("lead")) breaks.push(index);
  });
  breaks.push($(".js-item").length + 1); // Create Items

  $.each(breaks, function (i, v) {
    var previousIndex = i - 1 < 0 ? last : i - 1 >= 0 ? i - 1 : 0,
        base = $("<div />"),
        last = $(".js-item").length + 1;
    popupContainer.find(".js-item").each(function (index, value) {
      $(this).attr("data-id", index);
      $(this).attr("data-size", $(this).find("h6").text());
      if (index >= v) return false;
      if (index <= breaks[previousIndex] - 1) return;

      if (index == breaks[previousIndex]) {
        $("<a />").addClass("custom-acc__title").html($(this).find("h6").text()).appendTo(names);
        return;
      }

      var sizeContainer = $("<ul />").addClass("custom-acc__item item-" + index),
          quantity = $(this).find("input").val();

      if (quantity > 0) {
        for (var size = 0; size < quantity; size++) {
          var item = $("<li />").addClass("item-" + index + "-" + size);
          var defaultText = $(this).find("h6");

          if (defaultText.length > 0) {
            defaultText = "Size " + defaultText.text();
          } else {
            defaultText = "Name";
          }

          $("<span />").text(defaultText).appendTo(item);
          $('<input type="text" placeholder="Enter Name" />').attr("id", "item-" + index + "-" + size).appendTo(item);
          $("<a />").addClass("js-disable").attr("data-trigger", "item-" + index + "-" + size).html('<i class="far fa-times"></i>').appendTo(item);
          item.appendTo(sizeContainer);
        }
      }

      sizeContainer.attr("data-product", $(this).find("input").data("id")).appendTo(base);
    });
    base.addClass("item-container").appendTo(names);
  });
});
$(".js-item input").on("change", function (e) {
  var val = $(this).val(),
      id = $(this).parent().data("id"),
      text = $(this).parent().data("size"),
      fields = $(".item-" + id + " li").length;

  if (val == 0) {
    $(".item-" + id).empty();
    return false;
  }

  if (val < fields) {
    $(".item-" + id + " li").last().remove();
    return false;
  }

  if (val >= fields) {
    for (var size = fields; size < val; size++) {
      var item = $("<li />").addClass("item-" + id + "-" + size);
      var defaultText = "Size " + text;

      if (defaultText.length < 1) {
        defaultText = "Name";
      }

      $("<span />").text(defaultText).appendTo(item);
      $('<input type="text" placeholder="Enter Name" />').attr("id", "item-" + id + "-" + size).appendTo(item);
      $("<a />").addClass("js-disable").attr("data-trigger", "item-" + id + "-" + size).html('<i class="far fa-times"></i>').appendTo(item);
      item.appendTo($(".item-" + id));
    }
  }
});
$(".js-no").on("click", function (e) {
  e.preventDefault();
  $(this).toggleClass("active");
  $(".js-yes").removeClass("active");
  $(".product-modal__container").fadeOut();
});
$(".js-add-cart").on("click", function (e) {
  e.preventDefault();
  var $modal_parent = $(this).parent();
  $(this).attr("disabled", "disabled").text("Adding Product to Cart"); // If Design is checked

  var $error_count = 0;
  $modal_parent.find(".js-error").remove();

  if (!$modal_parent.find(".design-item.selected").length) {
    $('<p style="color: red;text-align:right; margin:0;" class="js-error">Please select a design.</p>').insertAfter($modal_parent.find(".design-container"));
    $error_count++;
  } // Check Quantity


  if ($modal_parent.find(".js-total").length && $modal_parent.find(".js-total").text() == "0") {
    $('<p style="color: red;text-align:right; margin:0;" class="js-error">Please increase the quantity on at least one size.</p>').insertAfter($modal_parent.find(".product-modal__total"));
    $error_count++;
  } // Check Min QTY


  if ($modal_parent.find(".js-total").length && $modal_parent.find(".js-total").text() < $(".js-total").data("min") && $modal_parent.find(".js-total").data("min") != 36) {
    $('<p style="color: red;text-align:right; margin:0;" class="js-error">This product requires a minium order of ' + $modal_parent.find(".js-total").data("min") + " Items.</p>").insertAfter($modal_parent.find(".product-modal__total"));
    $error_count++;
  } // Manage Socks


  if ($modal_parent.find(".js-total").data("min") == "36") {
    var $check = 0;
    $modal_parent.find(".js-item").each(function (i, v) {
      if ($(this).children("input").val() > 0 && $(this).children("input").val() < 36) {
        $check++;
      }
    });

    if ($check > 0) {
      $('<p style="color: red;text-align:right; margin:0;" class="js-error">This product requires a minium order of ' + $modal_parent.find(".js-total").data("min") + " per size.</p>").insertAfter($modal_parent.find(".product-modal__total"));
      $error_count++;
    }
  }

  if ($error_count > 0) {
    $(this).removeAttr("disabled").text("Add to Cart");
    return false;
  } // Get all data and add to Cart


  var $design = $modal_parent.find(".design-item.selected").data("index"),
      $products = [],
      $items = []; // Build Products

  $modal_parent.find(".js-item input").each(function (i, v) {
    if ($(this).val() > 0) $products.push({
      id: $(this).data("id"),
      qty: $(this).val(),
      attr: $(this).data("attr"),
      pa: $(this).data("pa")
    });
  });

  if ($modal_parent.find(".js-yes").hasClass("active")) {
    $modal_parent.find("ul.custom-acc__item").each(function (index, value) {
      var $id = $(this).data("product");

      if ($(this).length > 0) {
        $items[index] = [];
        $items[index].push($id);
        $(this).children("li").each(function (i, v) {
          var $text = $(this).find("input").val();
          if (!$text) $text = "NO NAME";
          $items[index].push($text);
        });
      }
    });
  }

  var $action = "do_create_cart";

  if ($(this).hasClass("team-cart")) {
    $action = "do_create_team_cart";
  }

  var data = {
    id: $modal_parent.data("id"),
    store: $modal_parent.data("store"),
    design: $design,
    products: $products,
    items: $items
  };
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: $action,
      custom_names: data
    },
    success: function success(res) {
      if (res.success) {
        if ($action == "do_create_cart") {
          window.location.replace(res.data);
        } else {
          // Check if .reveal-overlay is displayed as block
          //if ($(".reveal-overlay").css("display") === "block") {
          // Trigger click event on .close-button
          $(".reveal-overlay .close-button").click(); //}
          // Access the data

          var data = res.data; //Clear the modal

          $(".product-modal .design-item").removeClass("selected");
          $(".product-modal .js-item input").val("");
          $(".product-modal .product-modal__button").removeClass("active");
          $(".product-modal .product-modal__container").fadeOut();
          $(".product-modal .custom-acc__item li").remove();
          $(".product-modal .js-add-cart").removeAttr("disabled").text("Add to Cart"); // Select the existing container

          var msgCenter = $(".js-msg-center"); // Create unordered list element

          var ul = $("<ul>"); // Iterate over data

          $.each(data, function (index, item) {
            // Replace &#8211; with -
            item.title = item.title.replace(/&#8211;/g, "-"); // Create list item elements

            var li = $("<li>").text(item.qty + " x " + item.title + " (" + item.design + ") has been added to your cart."); // Append list item elements to unordered list

            ul.append(li);
          }); // Append view cart list item

          ul.append($("<li>").html('<a href="/cart/">View Cart</a>')); // Empty the existing container and append the unordered list

          msgCenter.empty().append(ul);
          fetchCartItemCount();
          $("html, body").animate({
            scrollTop: $(".js-msg-center").offset().top + 100
          }, 1000);
        }
      } else {
        if ($action == "do_create_cart") {
          alert("Unable to add Items to Cart, Please contact Limelight for assistance.");
        } else {
          var msgCenter = $(".js-msg-center");
          $(".js-msg-center").text("Unable to add to Cart.");
        }
      }
    }
  });
}); // Function to fetch cart item count

function fetchCartItemCount() {
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "get_cart_item_count" // Create a new AJAX action to get the cart item count

    },
    success: function success(res) {
      if (res.success) {
        // Update the cart icon with the item count
        updateCartIcon(res.data.count);
      }
    }
  });
} // Function to update cart icon with item count


function updateCartIcon(count) {
  var $cartLink = $(".limelight-account-login");
  var $countSpan = $cartLink.find("span");

  if ($countSpan.length === 0) {
    // If <span> doesn't exist, create and append it
    $countSpan = $("<span>").appendTo($cartLink);
  }

  $countSpan.text(count);
}

$(".js-confirm").on("change", function (e) {
  e.preventDefault();
  $(this).parent().parent().parent().parent().toggleClass("confirmed");
});
$(".js-edit").on("click", function (e) {
  e.preventDefault();
  $(this).parent().parent().parent().siblings(".edit-details").fadeIn();
  $(this).parent().parent().parent().siblings(".edit-details").find(".edit-qty").fadeIn();
  $("body").css({
    overflow: "hidden"
  });
});
$(".js-edit-design").on("click", function (e) {
  e.preventDefault();
  $(this).parent().parent().parent().siblings(".edit-details").fadeIn();
  $(this).parent().parent().parent().siblings(".edit-details").find(".edit-design").fadeIn();
  $("body").css({
    overflow: "hidden"
  });
});
$(".js-edit-names").on("click", function (e) {
  e.preventDefault();
  $(this).parent().parent().parent().find(".edit-details").fadeIn();
  $(this).parent().parent().parent().find(".edit-details").find(".edit-qty").fadeIn();
  $("body").css({
    overflow: "hidden"
  });
});
/* Cart edit */

$(document).on("click", ".product-edit-a", function (e) {
  e.preventDefault();
  var $popup = $(".edit-details");
  var $row = $(this).closest("tr");
  var product_id = $(this).data("id");
  var cartItemKey = $(this).data("key");
  var store_id = $row.find(".variation-Store p").text().trim();
  var quantity = $row.find(".product-quantity span").text().trim();
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "edit_product",
      product_id: product_id,
      store_id: store_id,
      quantity: quantity,
      cart_item_key: cartItemKey
    },
    success: function success(res) {
      if (res.success) {
        $(".edit-details").html(res.data);
        $popup.fadeIn();
        $(".edit-qty").fadeIn();
        $("body").css({
          overflow: "hidden"
        }); //$("body").addClass("popup-open");

        /* Close popup handle ajax popup event */
      } else {}
    }
  });
});
$(document).on("click", ".toggle-qty", function (e) {
  e.preventDefault();
  $(this).siblings(".edit-design").slideUp();
  $(this).siblings(".edit-qty").slideToggle();
});
$(document).on("click", ".toggle-design", function (e) {
  e.preventDefault();
  $(this).siblings(".edit-qty").slideUp();
  $(this).siblings(".edit-design").slideToggle();
});
$(document).on("click", ".js-close-details", function (e) {
  e.preventDefault();
  $(".edit-details").fadeOut();
  $("body").removeClass("popup-open");
  $("body").removeAttr("style");
});
$(document).on("click", ".js-delete-item", function (e) {
  e.preventDefault();
  var $parent = $(this).parent(),
      $check = $parent.parent().data("check"),
      $unique = $parent.parent().data("unique");
  $('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] .qty-total').html(parseInt($('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] .qty-total').html(), 10) - 1);
  $parent.remove(); // Length 0 Check
});
$(document).on("click", ".js-add-member", function (e) {
  e.preventDefault();
  var $check = $(this).siblings("ul").data("check");
  var $unique = $(this).siblings("ul").data("unique");
  var item = $("<li />");
  $("<span />").text($(this).data("size")).appendTo(item);
  $('<input type="text" placeholder="No Name" />').appendTo(item);
  $("<a />").addClass("js-delete-item").html("Delete").appendTo(item);
  item.appendTo($(this).siblings("ul"));
  $('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] .qty-total').html(parseInt($('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] .qty-total').html(), 10) + 1);
});
$(document).on("click", ".js-save-edits", function (e) {
  e.preventDefault();
  $("body").removeAttr("style");
  var $check = $(this).data("check");
  var $unique = $(this).data("unique");

  if ($('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"]').hasClass("no-names")) {
    $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-nqty').html($('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] input').val());
  } else {
    $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-names').empty();
    $('ul[data-check="' + $check + '"][data-unique="' + $unique + '"] input').each(function (i, v) {
      var item = $("<li />");
      if ($(this).val() == "") $(this).val("NO NAME");
      item.text($(this).val());
      item.appendTo($('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-names'));
    });
    $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-nqty').html($('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] .qty-total').html());
  } // Design


  $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-design-name').text($('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] .design-item.selected').data("index"));
  $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-image').attr("src", $('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"] .design-item.selected').data("image"));
  var $names;

  if ($('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-names').length) {
    $names = [];
    $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"] .js-names li').each(function () {
      $names.push($(this).text());
    });
  } // CHange order data


  var $data = {
    proofid: $(".proofs").data("id"),
    id: $check,
    qty: $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"]').find(".js-nqty").text(),
    design: $('.proofs-item[data-check="' + $check + '"][data-unique="' + $unique + '"]').find(".js-design-name").text(),
    names: $names,
    current: $(this).data("current")
  }; // Block Actions until complete

  $(".js-confirm").attr("disabled", "disabled");
  $(".js-review").addClass("saving-data");
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "do_update_from_proof",
      data: $data
    },
    success: function success(res) {
      $(".js-confirm").removeAttr("disabled");
      $(".js-review").removeClass("saving-data");
    }
  });
  $("body").removeAttr("style");
  $('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"]').fadeOut();
});
$(".js-confirm").on("click", function (e) {
  var $check = $(this).parent().parent().parent().parent().data("check");
  var $unique = $(this).parent().parent().parent().parent().data("unique");
  var $data = {
    lock: $(this).is(":checked") ? 1 : 0,
    id: $check,
    proofid: $(".proofs").data("id")
  };
  var $loader = $(this).parent().parent().parent().siblings(".loading"); // Block Actions until complete

  $(".js-confirm").attr("disabled", "disabled");
  $(".js-review").addClass("saving-data"); // Block Interactions

  $loader.fadeIn();
  $(".switch_box").css({
    pointerEvents: "none",
    opacity: "0.5",
    cursor: "wait"
  });
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "do_lock_item",
      data: $data
    },
    success: function success(res) {
      if (res.success) {
        $loader.fadeOut();
        $(".switch_box").removeAttr("style");
        $(".js-confirm").removeAttr("disabled");
        $(".js-review").removeClass("saving-data");
      } else {
        alert("Issue with Updating Order. Please contact us with your Reference Number");
      }
    }
  });
});
$('.proofs input[type="checkbox"]').on("click", function () {
  var $allow = 0;
  $('.proofs input[type="checkbox"]').each(function () {
    if (!$(this).is(":checked")) $allow++;
  });

  if ($allow == 0) {
    $(".js-review").removeAttr("disabled");
  } else {
    $(".js-review").attr("disabled", "disabled");
  }
});
$(".js-review").on("click", function (e) {
  e.preventDefault();
  var $href = $(this).attr("href");
  var $data = {
    proofid: $(".proofs").data("id")
  };
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "do_lock_cart",
      data: $data
    },
    success: function success(res) {
      window.location.replace($href);
    }
  });
});

if ($(".woocommerce-checkout").length > 0) {
  if ($(".cart-hero__heading") == "Order Summary") {
    $(".cart-hero__bar ul li").removeClass("active");
    $(".cart-hero__bar ul li:last-child").addClass("active");
  }
}

$("#js-place-rent-order").on("click", function (e) {
  e.preventDefault();
  $("#gform_submit_button_6").click();
});
$("#js-place-design-order").on("click", function (e) {
  e.preventDefault();
  var $this = $(this);
  $(this).attr("disabled", "disabled");

  if (location.href.indexOf("#gf_8") != -1) {
    $("#gform_submit_button_8").trigger("click");
  }

  if (location.href.indexOf("#gf_9") != -1) {
    $("#gform_submit_button_9").trigger("click");
    $("#gform_submit_button_9").click();
  }

  setTimeout(function () {
    $this.removeAttr("disabled");
  }, 2000);
});

if ($(".no-check").length) {
  $(".payment_method_cheque").remove();
}

$(".js-image").on("click", function (e) {
  e.preventDefault();
  $("#image-lightbox").foundation("open");
  $("#image-lightbox .js-large-image").attr("src", $(this).attr("src"));
});
$(".js-get-country").on("change", function (e) {
  if ($(this).val() == "*") return;
  $(".sample-design").show();

  if ($(this).val() == "Canada") {
    $(".form-ca").fadeIn("slow");
    $(".form-us").fadeOut("fast");
    $("#input_8_70").val($(this).val()); //sample sale

    $("#input_14_70").val($(this).val());
    $(".sample-design .rent-order-tax").show();
    $(".sample-design .rent-order-subtotal").show();
    $(".sample-design .js-design-subtotal,.sample-design .js-design-total").text($(".rent-custom .ginput_total").text());
  } else {
    $(".form-us").fadeIn("slow");
    $(".form-ca").fadeOut("fast");
    $("#input_9_70").val($(this).val());
    $("#input_15_70").val($(this).val());
    $(".sample-design .rent-order-tax").hide();
    $(".sample-design .rent-order-subtotal").hide();
    $(".sample-design .js-design-subtotal,.sample-design .js-design-total").text($(".rent-custom .ginput_total").text());
  }
}); // Check if the body has the class 'user-not-logged-in'

if ($("body").hasClass("user-not-logged-in")) {
  // Get all input fields that start with 'shipping_' and disable them
  $('input[name^="shipping_"]').prop("disabled", true); // Disable the checkbox with ID 'ship-to-different-address-checkbox'

  $("#ship-to-different-address-checkbox").prop("disabled", true);
}
/* new popup update function to update cart */


$(document).on("click", ".js-update-cart", function (e) {
  e.preventDefault();
  $(".edit-details .spinner-div").show();
  $("body").removeAttr("style");
  $("body").addClass("popup-open");
  var $check = $(this).data("check");
  var $unique = $(this).data("unique");
  var $popup_quantity, $design;

  if ($(".edit-popup-container").hasClass("no-names")) {
    $popup_quantity = $(".edit-popup-container input[type='number']").val();
    $popup_quantity = $popup_quantity.replace(/\s/g, "");
  } else {
    $(".edit-qty ul input").each(function (i, v) {
      var item = $("<li />");
      if ($(this).val() == "") $(this).val("NO NAME");
      item.text($(this).val());
      item.appendTo($(".edit-popup-container .js-names"));
    });
    $popup_quantity = $(".edit-popup-container .qty-total").text();
    $popup_quantity = $popup_quantity.replace(/\s/g, "");
  } // Design


  $design = $(".edit-popup-container .design-item.selected").data("index");
  var $names;

  if ($(".edit-popup-container .js-names").length) {
    $names = [];
    $(".edit-popup-container .js-names li").each(function () {
      $names.push($(this).text());
    });
  }

  $(".js-confirm").attr("disabled", "disabled");
  $(".js-review").addClass("saving-data"); // Send AJAX request to update cart

  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "do_update_cart",
      qty: $popup_quantity,
      design: $design,
      names: $names,
      cart_item_key: $(this).data("current")
    },
    success: function success(res) {
      location.reload();
    },
    error: function error(xhr, status, _error) {
      console.error("Error updating cart:", _error);
    }
  });
  $("body").removeAttr("style");
  $('.edit-details[data-check="' + $check + '"][data-unique="' + $unique + '"]').fadeOut();
});
/*Send po summary from single page */

$(document).on("click", ".js-send-po", function (e) {
  var store_id = $(this).data("id"); // AJAX request to send email

  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    dataType: "json",
    data: {
      action: "send_custom_email",
      store_id: store_id
    },
    success: function success(response) {
      alert("Email sent successfully!");
    },
    error: function error(xhr, status, _error2) {
      alert("Failed to send email. Please try again later.");
    }
  });
});
/*js to send _notification on shop approval */

$(".js-send-notification").click(function () {
  var user_id = $(this).data("user");
  var url = $(this).data("link");
  $.ajax({
    url: ajax_object.ajaxURL,
    type: "POST",
    data: {
      action: "send_notification_email",
      user_id: user_id,
      url: url
    },
    success: function success(response) {
      // Handle success
      alert("Notification email sent!");
    },
    error: function error(xhr, status, _error3) {
      // Handle error
      console.error(_error3);
    }
  });
}); //popup on single team

lightGallery(document.getElementById("team"), {
  selector: ".popup-image"
});
/* copy url */

$(document).ready(function () {
  $("#copyShopUrlBtn").click(function () {
    var url = $(this).data("url");
    copyToClipboard(url);
    alert("Shop URL copied to clipboard!");
  });
});

function copyToClipboard(text) {
  var input = document.createElement("input");
  input.style.position = "fixed";
  input.style.opacity = 0;
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
}